import React, { useEffect, useState } from "react";
// import { UserHeader } from "../components/UserHeader";
import { PackageDto } from "../types/package.types";
import { getPackages } from "../services/package.service";
import { showError, showSuccess } from "../utils/notifications";
import styles from "./css/PackagesPage.module.css";

export const PackagesPage: React.FC = () => {
  const [packages, setPackages] = useState<PackageDto[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const data = await getPackages();
      setPackages(data);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || error?.message || "שגיאה בטעינת החבילות";
      console.error("[DEBUG] Full error:", error);
      showError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handlePurchase = (packageName: string) => {
    showSuccess(`בקשת רכישה ל-${packageName} התקבלה בהצלחה`);
    console.log(`Purchase request for: ${packageName}`);
    // כאן אפשר להוסיף לוגיקה של ניווט לעמוד תשלום או payment gateway
  };

  const getPackageIcon = (name: string) => {
    const nameUpper = name.toUpperCase();
    if (nameUpper.includes("PRO")) return "⭐";
    if (nameUpper.includes("BASIC")) return "📦";
    if (nameUpper.includes("FREE") || nameUpper.includes("FEE")) return "🎁";
    return "💼";
  };

  const isProPackage = (name: string) => name.toUpperCase().includes("PRO");

  return (
    <div>
      {/* <UserHeader /> */}
      <div className={styles.packagesContainer}>
        <div className={styles.packagesContent}>
          <h1 className={styles.packagesTitle}>חבילות שלנו</h1>

          {loading && (
            <div className={styles.loadingContainer}>
              <span className={styles.loadingSpinner}>⏳</span>
              טוען את החבילות...
            </div>
          )}

          {!loading && packages.length === 0 && (
            <div className={styles.noPackages}>
              <p>אין חבילות זמינות כרגע</p>
            </div>
          )}

          {!loading && packages.length > 0 && (
            <div className={styles.packagesGrid}>
              {packages.map((pkg) => (
                <div
                  key={pkg.id}
                  className={`${styles.packageCard} ${isProPackage(pkg.name) ? styles.proCard : ""}`}
                >
                  <div className={styles.packageIconSection}>
                    {getPackageIcon(pkg.name)}
                  </div>
                  <h2 className={styles.packageName}>{pkg.name}</h2>
                  {pkg.description && (
                    <p className={styles.packageDescription}>{pkg.description}</p>
                  )}
                  {pkg.price != null && (
                    <div className={styles.priceSection}>
                      <span className={styles.price}>
                        {pkg.price === 0 ? "חינם" : `₪${pkg.price}`}
                      </span>
                    </div>
                  )}
                  <button
                    className={styles.purchaseButton}
                    onClick={() => handlePurchase(pkg.name)}
                  >
                    בחר חבילה
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PackagesPage;
